import { useRef } from 'react';

export const useId = () => {
  const { current: id } = useRef(`${Math.random()}`);
  return id;
};
